export function toLowerCamelCase (str) {
  return str.charAt(0).toLowerCase() + str.slice(1)
}

export function convertKeysToCamelCase (obj) {
  if (Array.isArray(obj)) {
    return obj.map(item => convertKeysToCamelCase(item))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const newKey = toLowerCamelCase(key)
      acc[newKey] = convertKeysToCamelCase(obj[key])
      return acc
    }, {})
  }
  return obj
}

export function toUpperCamelCase (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function convertKeysToPascalCase (obj) {
  if (Array.isArray(obj)) {
    return obj.map(item => convertKeysToPascalCase(item))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((acc, key) => {
      const newKey = toUpperCamelCase(key)
      acc[newKey] = convertKeysToPascalCase(obj[key])
      return acc
    }, {})
  }
  return obj
}
